import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordField } from "./PasswordField";

const EMPTY = { name: "", email: "", password: "" };

export const AddDriverDialog = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const close = () => { setForm(EMPTY); setError(""); onClose(); };
  const valid = form.name.trim() && /\S+@\S+\.\S+/.test(form.email) && form.password.length >= 8;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const err = await onSubmit(form);
    setBusy(false);
    if (err) setError(err);
    else setForm(EMPTY);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && close()}>
      <DialogContent className="max-w-lg" data-testid="add-driver-dialog">
        <DialogHeader>
          <DialogTitle>Add driver</DialogTitle>
          <DialogDescription>This creates a login right away. No email is sent.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="driver-name">Full name</Label>
            <Input id="driver-name" className="mt-1.5 h-11" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g. Mike Johnson" data-testid="driver-name-input" />
          </div>
          <div>
            <Label htmlFor="driver-email">Email</Label>
            <Input id="driver-email" type="email" className="mt-1.5 h-11" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="driver@example.com" data-testid="driver-email-input" />
          </div>
          <PasswordField value={form.password} onChange={(password) => setForm({ ...form, password })} />
          {error && <p className="text-sm text-rose-600" data-testid="add-driver-error">{error}</p>}
          <DialogFooter className="gap-2 sm:gap-2">
            <Button type="button" variant="outline" onClick={close} data-testid="add-driver-cancel-btn">Cancel</Button>
            <Button type="submit" disabled={!valid || busy} className="bg-[#002FA7] hover:bg-[#001A75]" data-testid="add-driver-submit-btn">
              {busy ? "Creating…" : "Create driver"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
